// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';


export class ServiceEndpointViewModel {
    id: number = 0;
	name: string = null;
	uri: string = null;
	entity: string = null;
	isXMLCall: boolean = false;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        ValidationRules
			.ensure('name').displayName('Naam').required().maxLength(128)
			.ensure('uri').displayName('Uri').required().maxLength(128)
			.ensure('entity').displayName('Entiteit').required()
			.on(this);
	}
}